import { locatorServiceAPI } from 'shared/services';

import {
  ActiveCard,
  OrderFirstStepOptions,
  OrderFirstStepResult,
  OrderSecondStepOptions,
  OrderSecondStepResult
} from '../types';

export const cardsAPI = {
  getActiveCards: () => locatorServiceAPI.get<ActiveCard[]>('cards/active'),
  orderFirstStep: (data: OrderFirstStepOptions) => locatorServiceAPI.put<OrderFirstStepResult>('cards/order', data),
  orderSecondStep: (data: OrderSecondStepOptions) => locatorServiceAPI.post<OrderSecondStepResult>('cards/order', data)
};
